'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'thumbs-up';
var width = 512;
var height = 512;
var aliases = [128077,61575];
var unicode = 'f164';
var svgPathData = ['M128 190.5l0 198 16.8 12 56 40c3.5 2.5 6.9 5 10.4 7.5l188.8 0 0-64 16 0 0-64 16 0 0-64 16 0 0-64-238.2 0c3.8-6.8 23-40.9 57.6-102.3l17.7-31.4-62.7-35.3-17.7 31.4-72 128-4.6 8.2z', 'M224-12.7l90.6 51 13.9 7.8c-5 8.9-52.9 93.9-64.1 113.9l215.5 0 0 128-16 0 0 64-16 0 0 64-16 0 0 64-231.1 0-4.2-3-14.6-10.4 0 0-54.1-38.7 0 52.1-128 0 0-320 108.5 0C228.1-52.6 197.8 1.3 210.1-20.6L224-12.7zM32 448l64 0 0-256-64 0 0 256zM204.6 54.4l-72 128-4.6 8.2 0 198 16.8 12 56 40 0 0 10.5 7.5 188.8 0 0-64 16 0 0-64 16 0 0-64 16 0 0-64-238.2 0c3.8-6.8 23-40.9 57.6-102.3l17.7-31.4-62.7-35.3-17.7 31.4z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faThumbsUp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;